// Loads remote HTML into the opportunities quick-edit drawer.
// Called from inline onclick handlers on Opportunity cards.
export function loadQuickEdit(url) {
  const container = document.getElementById("quick-edit-content");
  if (!container) return;

  container.innerHTML =
    '<div class="flex justify-center py-8"><div class="h-6 w-6 animate-spin rounded-full border-2 border-primary-600 border-t-transparent"></div></div>';

  const drawer = document.getElementById("quick-edit-drawer");
  const failedMsg = drawer?.dataset.loadFailed || "Failed to load";

  fetch(url, {
    headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" }
  })
    .then((r) => r.text())
    .then((html) => {
      container.innerHTML = html;
    })
    .catch(() => {
      container.innerHTML = `<p class="text-sm text-red-500">${failedMsg}</p>`;
    });
}

export default function registerQuickEditDrawer() {
  window.loadQuickEdit = loadQuickEdit;
}
